import can from 'can';
import _ from 'lodash';
import listTemplate from './player-list.stache';
import PlayerService from 'scripts/services/player-service';
import cloudinaryUtil from 'scripts/utils/cloudinary';

const playerQualifiers = {
    all: 'ALL PLAYERS',
    isAmateur: 'AMATEURS',
    isChampion: 'U.S. OPEN CHAMPIONS',
    // TODO: remove comment after USOpen 2020 ends
    // localQualifier: 'LOCAL QUALIFIERS',
    // sectionalQualifier: 'FINAL QUALIFIERS',
    // exemptions: 'EXEMPT FROM QUALIFICATION',
};

const playerPageUrl = window.globalSettings.pagePaths.player;

const playerListFilter = can.Map.extend({
    name: '',
    qualifier: 'all',
    sort: 'alphabetical',
    playerQualifiers,
    isOrderAlphabetical: function() {
        return this.attr('sort') === 'alphabetical';
    },
});

can.Component.extend({
    tag: 'player-list',
    template: listTemplate,
    viewModel: {
        filter: new playerListFilter(),
        favorites: PlayerService.getFavorites(),
        define: {
            players: {
                type: '*',
            },
            filteredPlayers: {
                type: '*',
                get() {
                    const filter = this.attr('filter');
                    const players = this.attr('players') || [];
                    const filteredPlayers = players.filter((player) => {
                        let result = true;
                        if (filter.attr('name')) {
                            result =
                                player.lastName
                                    .toLowerCase()
                                    .indexOf(filter.name.toLowerCase()) === 0 ||
                                player.firstName
                                    .toLowerCase()
                                    .indexOf(filter.name.toLowerCase()) === 0;
                        }
                        if (result && filter.attr('qualifier') !== 'all') {
                            result =
                                player.qualifiers.indexOf(filter.qualifier) !==
                                -1;
                        }
                        return result;
                    });

                    if (!filteredPlayers.length) {
                        return false;
                    }

                    const computedResult = {};
                    if (filter.isOrderAlphabetical()) {
                        _.sortBy(filteredPlayers, 'lastName').forEach(
                            (player) => {
                                if (player.lastName) {
                                    const letter = player.lastName
                                        .toUpperCase()
                                        .slice(0, 1);
                                    if (!computedResult[letter]) {
                                        computedResult[letter] = [player];
                                    } else {
                                        computedResult[letter].push(player);
                                    }
                                }
                            },
                        );
                    } else {
                        _.sortBy(filteredPlayers, 'country.name').forEach(
                            (player) => {
                                if (player.country && player.country.name) {
                                    const countryCode = player.country.name.toUpperCase();
                                    if (!computedResult[countryCode]) {
                                        //computedResult.attr(countryCode, (new can.List([player])).attr("comparator", "lastName"));
                                        computedResult[countryCode] = [player];
                                    } else {
                                        computedResult[countryCode].push(
                                            player,
                                        );
                                        computedResult[countryCode] = _.sortBy(
                                            computedResult[countryCode],
                                            'lastName',
                                        );
                                    }
                                }
                            },
                        );
                    }
                    return computedResult;
                },
            },
        },

        toggleFavorite(playerId) {
            PlayerService.toggleFavorite(playerId);
            return false;
        },

        getImageSrc(image) {
            return cloudinaryUtil.getCloudinaryPath(
                image.identifier,
                220,
                220,
                null,
                null,
                null,
                'max',
            );
        },

        playerDetailLink(playerId) {
            return can.sub(playerPageUrl, { playerId });
        },
    },

    init: function() {
        const players = this.viewModel.attr('players') || [];
        players.forEach((player) => {
            player.qualifiers = Object.keys(playerQualifiers).filter(
                (qualifier) => {
                    return Array.isArray(player[qualifier]) ||
                        player[qualifier] instanceof can.List
                        ? !!player[qualifier].length
                        : !!player[qualifier];
                },
            );
        });
    },
});
